import { ImageService } from "@DavisDigital/davisdigitalfrontend.module";
import { PageImage } from "@DavisDigital/interfaces";


class AddEditPageImageNoteModalController {
    
    private close:Function; //injected from modal-service
    
    public pageImage: PageImage;
    
    public modalTitle = "Add new Note";
    public successMessage: string;
    public isLoading = false;
    public isSaveSuccess = false;
	
	// @ngInject
	constructor(
	    private imageService: ImageService
	){}
	
	public $onInit = () => {
	    if(this.pageImage?.pageImageNote?.pageImageNoteID?.trim?.().length){
	        this.modalTitle = "Update Note";
	    }
	}
	
	public onSave = () => {
	    this.isLoading = true;
	    
	    this.imageService.savePageImageNote({
	        note: this.pageImage.pageImageNote.note,
	        pageImageID: this.pageImage.pageImageID,
	        pageImageNoteID: this.pageImage.pageImageNote.pageImageNoteID,
	    })
	    .then( pageImageNote => {
	        
	        this.pageImage.pageImageNote.note = pageImageNote.note;
	        this.pageImage.pageImageNote.pageImageNoteID =  pageImageNote.pageImageNoteID;
	        this.pageImage.pageImageNote.createdDatetime = pageImageNote.createdDatetime;
	        this.pageImage.pageImageNote.modifiedDateTime = pageImageNote.modifiedDateTime;
	        
	        this.isSaveSuccess = true;
	        this.successMessage = `Note has been savd successfully`;
	    })
	    .catch(console.error)
	    .finally( () => this.isLoading = false )
	}
	
    private closeModal = () => {
        this.close?.( this.isSaveSuccess ? this.pageImage : null );
    }
}

class AddEditPageImageNoteModal {
	public restrict: string = 'E';
	public scope:{};
	
	public bindToController = {
	    pageImage: "<",
		close:'='
	};

	public controller = AddEditPageImageNoteModalController;
	public controllerAs = 'pageImageNoteModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/modals/add-edit-page-image-note-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { AddEditPageImageNoteModal };
